module.exports = __webpack_public_path__ + "img/motorway_8x2_z18.525a9ebb.svg";